import Axios from "axios";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { configContext } from "../../components/config-provider";
import { IApplicationState } from "../../state/ducks";
import { authAsync } from "../../state/ducks/auth";

export const Login: React.FC = (props) => {
	const dispatch = useDispatch();
	const state = useSelector<IApplicationState, IApplicationState["auth"]>(
		(state) => state.auth
	);

	const {
		oauth: { clientId, redirectURL, server },
		baseURL,
	} = React.useContext(configContext);

	const history = useHistory();
	const params = new URLSearchParams(window.location.search);
	const result = params.get("result");

	const oauthURL = `${server}?client_id=${clientId}&redirect_uri=${redirectURL}&scope=rw`;

	React.useEffect(() => {
		if (result) {
			const json = JSON.parse(result);
			const instance = Axios.create({ baseURL });
			instance
				.post("/auth/token", { code: json.code })
				.then((res) => {
					dispatch(authAsync(res.data));
				})
				.catch((err) => {
					setTimeout(() => {
						window.location.href = oauthURL;
					}, 2000);
				});
		}
	// eslint-disable-next-line
	}, []);

	React.useLayoutEffect(() => {
		if (state.token.isAuthenticated) {
			history.push("/dashboard");
		} else {
			if (!result) {
				window.location.href = oauthURL;
			}
		}
	// eslint-disable-next-line
	}, [state]);

	return <>Loading</>;
};
